var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/rules-of-hooks */
import { Box, Button, IconButton } from '@chakra-ui/react';
import { RecordScope, RecordsScope, useField, useFieldSchema } from '@formily/react';
import { clone, isValid } from '@formily/shared';
import React, { createContext, useContext } from 'react';
import { RiAddLine, RiArrowDownLine, RiArrowUpLine, RiDeleteBinLine, RiFileCopyLine } from 'react-icons/ri';
const ArrayBaseContext = createContext(null);
const ItemContext = createContext(null);
const takeRecord = (val) => (typeof val === 'function' ? val() : val);
const useArray = () => {
    return useContext(ArrayBaseContext);
};
const useIndex = (index) => {
    const ctx = useContext(ItemContext);
    return ctx ? ctx.index : index || 0;
};
const useRecord = (record) => {
    const ctx = useContext(ItemContext);
    return takeRecord(ctx ? ctx.record : record);
};
const useSize = (size) => {
    const ctx = useContext(ItemContext);
    return (ctx ? ctx.size : size) || 'md';
};
const getSchemaDefaultValue = (schema) => {
    if ((schema === null || schema === void 0 ? void 0 : schema.type) === 'array')
        return [];
    if ((schema === null || schema === void 0 ? void 0 : schema.type) === 'object')
        return {};
    if ((schema === null || schema === void 0 ? void 0 : schema.type) === 'void') {
        for (let key in schema.properties) {
            const value = getSchemaDefaultValue(schema.properties[key]);
            if (isValid(value))
                return value;
        }
    }
};
const getDefaultValue = (defaultValue, schema) => {
    if (isValid(defaultValue))
        return clone(defaultValue);
    if (Array.isArray(schema === null || schema === void 0 ? void 0 : schema.items))
        return getSchemaDefaultValue(schema.items[0]);
    return getSchemaDefaultValue(schema.items);
};
export const ArrayBase = (props) => {
    const field = useField();
    const schema = useFieldSchema();
    return (_jsx(RecordsScope, Object.assign({ getRecords: () => field.value }, { children: _jsx(ArrayBaseContext.Provider, Object.assign({ value: { field, schema, props } }, { children: props.children })) })));
};
ArrayBase.Item = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(ItemContext.Provider, Object.assign({ value: props }, { children: _jsx(RecordScope, Object.assign({ getIndex: () => props.index, getRecord: () => takeRecord(props.record) }, { children: children })) })));
};
// const SortHandle = SortableHandle((props: any) => {
//   const prefixCls = usePrefixCls('formily-array-base');
//   return (
//     <MenuOutlined
//       {...props}
//       className={cls(`${prefixCls}-sort-handle`, props.className)}
//       style={{ ...props.style }}
//     />
//   );
// }) as any;
// ArrayBase.SortHandle = (props) => {
//   const array = useArray();
//   if (!array) return null;
//   if (array.field?.pattern !== 'editable') return null;
//   return <SortHandle {...props} />;
// };
ArrayBase.Index = (props) => {
    const index = useIndex();
    return (_jsxs(Box, Object.assign({ textAlign: "center" }, props, { children: ["#", index + 1] })));
};
ArrayBase.Addition = (props) => {
    var _a, _b;
    const self = useField();
    const array = useArray();
    if (!array)
        return null;
    if (((_a = array.field) === null || _a === void 0 ? void 0 : _a.pattern) !== 'editable' && ((_b = array.field) === null || _b === void 0 ? void 0 : _b.pattern) !== 'disabled')
        return null;
    return (_jsx(Button, Object.assign({ variant: "outline", iconSpacing: "0.5" }, props, { disabled: self === null || self === void 0 ? void 0 : self.disabled, onClick: (e) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if ((_a = array.props) === null || _a === void 0 ? void 0 : _a.disabled)
                return;
            const defaultValue = getDefaultValue(props.defaultValue, array.schema);
            if (props.method === 'unshift') {
                (_c = (_b = array.field) === null || _b === void 0 ? void 0 : _b.unshift) === null || _c === void 0 ? void 0 : _c.call(_b, defaultValue);
                (_e = (_d = array.props) === null || _d === void 0 ? void 0 : _d.onAdd) === null || _e === void 0 ? void 0 : _e.call(_d, 0);
            }
            else {
                (_g = (_f = array.field) === null || _f === void 0 ? void 0 : _f.push) === null || _g === void 0 ? void 0 : _g.call(_f, defaultValue);
                (_j = (_h = array.props) === null || _h === void 0 ? void 0 : _h.onAdd) === null || _j === void 0 ? void 0 : _j.call(_h, ((_l = (_k = array === null || array === void 0 ? void 0 : array.field) === null || _k === void 0 ? void 0 : _k.value) === null || _l === void 0 ? void 0 : _l.length) - 1);
            }
            if (props.onClick) {
                props.onClick(e);
            }
        }, leftIcon: _jsx(RiAddLine, { size: 20 }) }, { children: props.title || self.title })));
};
const iconButtonStyles = {
    variant: 'text',
    _notLast: {
        marginRight: -1,
    },
};
ArrayBase.Copy = React.forwardRef((props, ref) => {
    var _a;
    const self = useField();
    const array = useArray();
    const index = useIndex(props.index);
    const size = useSize(props.size);
    if (!array)
        return null;
    if (((_a = array.field) === null || _a === void 0 ? void 0 : _a.pattern) !== 'editable')
        return null;
    return (_jsx(IconButton, Object.assign({ ref: ref, size: size, icon: _jsx(RiFileCopyLine, {}) }, iconButtonStyles, props, { disabled: self === null || self === void 0 ? void 0 : self.disabled, "aria-label": "Copy the row of Array", onClick: (e) => {
            var _a, _b, _c, _d, _e, _f;
            if (self === null || self === void 0 ? void 0 : self.disabled)
                return;
            e.stopPropagation();
            if ((_a = array.props) === null || _a === void 0 ? void 0 : _a.disabled)
                return;
            const value = clone((_b = array === null || array === void 0 ? void 0 : array.field) === null || _b === void 0 ? void 0 : _b.value[index]);
            const distIndex = index + 1;
            (_d = (_c = array.field) === null || _c === void 0 ? void 0 : _c.insert) === null || _d === void 0 ? void 0 : _d.call(_c, distIndex, value);
            (_f = (_e = array.props) === null || _e === void 0 ? void 0 : _e.onCopy) === null || _f === void 0 ? void 0 : _f.call(_e, distIndex);
            if (props.onClick) {
                props.onClick(e);
            }
        } })));
});
ArrayBase.Remove = React.forwardRef((props, ref) => {
    var _a;
    const index = useIndex(props.index);
    const self = useField();
    const array = useArray();
    const size = useSize(props.size);
    if (!array)
        return null;
    if (((_a = array.field) === null || _a === void 0 ? void 0 : _a.pattern) !== 'editable')
        return null;
    return (_jsx(IconButton, Object.assign({ ref: ref, size: size, icon: _jsx(RiDeleteBinLine, {}) }, iconButtonStyles, props, { disabled: self === null || self === void 0 ? void 0 : self.disabled, "aria-label": "Remove the row from Array", onClick: (e) => {
            var _a, _b, _c, _d;
            if (self === null || self === void 0 ? void 0 : self.disabled)
                return;
            e.stopPropagation();
            (_b = (_a = array.field) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a, index);
            (_d = (_c = array.props) === null || _c === void 0 ? void 0 : _c.onRemove) === null || _d === void 0 ? void 0 : _d.call(_c, index);
            if (props.onClick) {
                props.onClick(e);
            }
        } })));
});
ArrayBase.MoveDown = React.forwardRef((props, ref) => {
    var _a;
    const index = useIndex(props.index);
    const self = useField();
    const array = useArray();
    const size = useSize(props.size);
    if (!array)
        return null;
    if (((_a = array.field) === null || _a === void 0 ? void 0 : _a.pattern) !== 'editable')
        return null;
    return (_jsx(IconButton, Object.assign({ ref: ref, size: size, icon: _jsx(RiArrowDownLine, {}) }, iconButtonStyles, props, { disabled: self === null || self === void 0 ? void 0 : self.disabled, "aria-label": "MoveDown the row of Array", onClick: (e) => {
            var _a, _b, _c, _d;
            if (self === null || self === void 0 ? void 0 : self.disabled)
                return;
            e.stopPropagation();
            (_b = (_a = array.field) === null || _a === void 0 ? void 0 : _a.moveDown) === null || _b === void 0 ? void 0 : _b.call(_a, index);
            (_d = (_c = array.props) === null || _c === void 0 ? void 0 : _c.onMoveDown) === null || _d === void 0 ? void 0 : _d.call(_c, index);
            if (props.onClick) {
                props.onClick(e);
            }
        } })));
});
ArrayBase.MoveUp = React.forwardRef((props, ref) => {
    var _a;
    const index = useIndex(props.index);
    const self = useField();
    const array = useArray();
    const size = useSize(props.size);
    if (!array)
        return null;
    if (((_a = array.field) === null || _a === void 0 ? void 0 : _a.pattern) !== 'editable')
        return null;
    return (_jsx(IconButton, Object.assign({ ref: ref, size: size, icon: _jsx(RiArrowUpLine, {}) }, iconButtonStyles, props, { disabled: self === null || self === void 0 ? void 0 : self.disabled, "aria-label": "MoveUp the row of Array", onClick: (e) => {
            var _a, _b, _c;
            if (self === null || self === void 0 ? void 0 : self.disabled)
                return;
            e.stopPropagation();
            (_a = array === null || array === void 0 ? void 0 : array.field) === null || _a === void 0 ? void 0 : _a.moveUp(index);
            (_c = (_b = array === null || array === void 0 ? void 0 : array.props) === null || _b === void 0 ? void 0 : _b.onMoveUp) === null || _c === void 0 ? void 0 : _c.call(_b, index);
            if (props.onClick) {
                props.onClick(e);
            }
        } })));
});
ArrayBase.useArray = useArray;
ArrayBase.useIndex = useIndex;
ArrayBase.useRecord = useRecord;
ArrayBase.useSize = useSize;
ArrayBase.mixin = (target) => {
    target.Index = ArrayBase.Index;
    // target.SortHandle = ArrayBase.SortHandle;
    target.Addition = ArrayBase.Addition;
    target.Copy = ArrayBase.Copy;
    target.Remove = ArrayBase.Remove;
    target.MoveDown = ArrayBase.MoveDown;
    target.MoveUp = ArrayBase.MoveUp;
    target.useArray = ArrayBase.useArray;
    target.useIndex = ArrayBase.useIndex;
    target.useRecord = ArrayBase.useRecord;
    target.useSize = ArrayBase.useSize;
    return target;
};
export default ArrayBase;
